/**
 * Работа с localStorage для сохранения выбора темы
 * # ⛓️ CURSOR_ANCHOR:ui:theme-storage
 */

(function() {
  'use strict';

  var THEME_STORAGE_KEY = window.THEME_CONSTANTS.STORAGE_KEY;
  var PROFILE_STORAGE_KEY = window.THEME_CONSTANTS.PROFILE_STORAGE_KEY;
  var THEME_LIGHT = window.THEME_CONSTANTS.LIGHT;
  var THEME_AUTO = window.THEME_CONSTANTS.AUTO;

  /**
   * Работа с Cookies
   */
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Получить текущую тему
   */
  function getStoredTheme() {
    try {
      var stored = localStorage.getItem(THEME_STORAGE_KEY) || getCookie('slovary_theme');
      
      if (!stored) {
        return THEME_AUTO;
      }
      
      return stored;
    } catch (e) {
      return THEME_AUTO;
    }
  }

  /**
   * Сохранить выбор темы
   */
  function setStoredTheme(theme) {
    try {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
      setCookie('slovary_theme', theme, 365);
      // Account-sync hook (account-sync.js): debounced server push.
      document.dispatchEvent(new CustomEvent('slovary-state-mutated', { detail: { kind: 'theme' } }));
    } catch (e) {
      console.warn('Failed to save theme preference:', e);
    }
  }

  /**
   * Получить текущий профиль
   */
  function getStoredProfile() {
    try {
      return localStorage.getItem(PROFILE_STORAGE_KEY) || getCookie('slovary_color_profile') || 'default';
    } catch (e) {
      return 'default';
    }
  }

  /**
   * Сохранить выбор профиля
   */
  function setStoredProfile(profile) {
    try {
      localStorage.setItem(PROFILE_STORAGE_KEY, profile);
      setCookie('slovary_color_profile', profile, 365);
      document.dispatchEvent(new CustomEvent('slovary-state-mutated', { detail: { kind: 'theme' } }));
    } catch (e) {
      console.warn('Failed to save profile preference:', e);
    }
  }

  window.THEME_STORAGE = {
    get: getStoredTheme,
    set: setStoredTheme,
    getProfile: getStoredProfile,
    setProfile: setStoredProfile
  };
})();

